import { motion } from "framer-motion";
import { PROOF_STATS } from "@/lib/data";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#050505] py-24 md:py-40 border-t border-white/10"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        {/* Section label */}
        <div className="flex items-center gap-3 mb-16">
          <span className="font-mono-label text-[10px] text-[#C4A484]">
            001 · The Work
          </span>
          <span className="flex-1 h-px bg-white/10" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            className="md:col-span-7"
          >
            <h2 className="font-heading text-5xl md:text-7xl leading-[1] tracking-tighter">
              We don&apos;t
              <br />
              film weddings.
              <br />
              <span className="italic text-[#C4A484]">
                We preserve moments
              </span>
              <br />
              people forget happened.
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            viewport={{ once: true }}
            className="md:col-span-5 md:pt-8 space-y-6 text-[#FDFBF7]/70 text-base leading-relaxed"
          >
            <p>
              Flyora Weddings is the wedding film division of{" "}
              <span className="text-[#FDFBF7]">Flyfilms</span> — an international
              cinematic studio building family archives one wedding at a time.
              Three cameras, two filmmakers, one story told from every angle.
            </p>
            <p className="text-[#8F8F8F]">
              Every tradition. Every setting. Kerala. Dubai. London. We travel
              to the day. We stay through the night. We come back with a film
              your children can watch thirty years from now.
            </p>
          </motion.div>
        </div>

        {/* Proof stats */}
        <div
          data-testid="proof-stats"
          className="mt-24 md:mt-32 grid grid-cols-1 md:grid-cols-4 gap-px bg-white/10 border border-white/10"
        >
          {PROOF_STATS.map((stat, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              viewport={{ once: true }}
              data-testid={`stat-${i}`}
              className="bg-[#050505] p-8 md:p-12"
            >
              <div className="flex items-baseline gap-2 mb-4">
                <span className="font-heading text-6xl md:text-7xl text-[#C4A484] tracking-tighter">
                  {stat.number}
                </span>
                <span className="font-heading text-2xl md:text-3xl text-[#FDFBF7]/60">
                  {stat.suffix}
                </span>
              </div>
              <p className="text-[#8F8F8F] text-sm leading-relaxed">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
